import usoCFDIJson from "../../../../dataComponets/invoice/usoCFDI.json";
import taxRegimenJson from "../../../../dataComponets/invoice/taxRegimen.json";
import tipoComprobanteJson from "../../../../dataComponets/invoice/tipo_comprobante.json";

import type { Option } from "../types/invoice";

export const usoCFDI = usoCFDIJson as Option[];
export const taxRegimen = taxRegimenJson as Option[];
export const tipoComprobante = tipoComprobanteJson as Option[];
